import { ApiError, apiPost } from './apiClient';
import { trackEvent } from './analyticsService';

/**
 * Names a recipe the app just saved so the server translates it into the other
 * language (translate at write, 2026-11-02). The id only: the server reads the
 * document and translates that, so no recipe text leaves the device for it.
 *
 * Off the cook's path and never throws. A request that does not land is no
 * loss: the hourly backstop translates what it finds untranslated. Until
 * RECIPE_TRANSLATE_AT_WRITE is on, the server answers at once and does nothing.
 */
export function requestTranslationAtWrite(recipeId: string, source: string): void {
  if (!recipeId) return;
  apiPost('/api/recipes/import', { action: 'translate', recipeId }, { requireSuccess: true }).catch((err) => {
    // Expected offline or signed out; the backstop covers it, so a replay note.
    console.warn('[translateAtWrite] request not delivered:', (err as Error)?.message);
    trackEvent('translation_request_failed', {
      source,
      status: err instanceof ApiError ? err.status : 0,
      code: err instanceof ApiError ? err.code : undefined,
    });
  });
}
